import { client } from "./client"
import { safeQueryOptions } from "@src/utils/query"

export const literalsKeys = {
  all: ["literals"],
}

export const getCommunityLiterals = async (communityId: number) => {
  return await client.GET("/api/CommunityLiteral/GetByCommunity", {
    params: {
      query: {
        communityId,
      },
    },
  })
}

export const getCommunityLiteralsQuery = (id?: number) =>
  safeQueryOptions({
    queryFn: getCommunityLiterals,
    queryKeys: literalsKeys.all,
    unsafeQueryFnArgs: [id],
  })

export type CommunityLiterals = {
  primitive_startup?: string
  primitive_startups?: string
  primitive_program?: string
  primitive_programs?: string
  [key: string]: string | undefined
}

export const saveCommunityLiterals = async (
  communityId: number,
  literals: CommunityLiterals,
) => {
  // Filter out undefined values for the API
  const cleanLiterals: { [key: string]: string } = {}
  for (const [key, value] of Object.entries(literals)) {
    if (value !== undefined && value !== "") {
      cleanLiterals[key] = value
    }
  }

  return await client.POST("/api/CommunityLiteral/Save/{communityId}", {
    params: {
      path: {
        communityId,
      },
    },
    body: cleanLiterals,
  })
}
